import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import Fragment from "vue-fragment";
import vuetify from "@/plugins/vuetify";
import store from "./store";
import VueTheMask from "vue-the-mask";
import VueI18n from "vue-i18n";
import DatetimePicker from "vuetify-datetime-picker";
import Vue2Editor from "vue2-editor";
import "@/style.css";
import "animate.css";

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import pt from "./i18n/pt";
import en from "./i18n/en";
import es from "./i18n/es";

Vue.config.productionTip = false;
Vue.use(Fragment.Plugin);
Vue.use(VueTheMask);
Vue.use(DatetimePicker);
Vue.use(VueI18n);
Vue.use(Vue2Editor);

Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true,
  position: "top-right",
  timeout: 6000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  closeButton: "button",
  rtl: false,
});

export const i18n = new VueI18n({
  locale: "pt_BR",
  fallbackLocale: "pt_BR",
  messages: {
    pt_BR: pt,
    en_US: en,
    es_ES: es,
  },
});

// FILTROS
import "@/helpers";

// PLUGINS
import "@/services";
import "@/plugins/config";

// VUETIFY MONEY PLUGIN
import "@/plugins/vuetify/vuetify-money.js";

import "@/controllers";

// CONTROLLER DASHBOARD
import "@/controllers/Dashboard.controller.js";

// CONTROLLER SAC
import "@/controllers/Sac.controller.js";

// CONTROLLERS PESSOAS
import "@/controllers/pessoas/Pessoas-Usuario.controller.js";
import "@/controllers/pessoas/Pessoas-Agentes.controller.js";
import "@/controllers/pessoas/Pessoas-TiposPDV.controller.js";
import "@/controllers/pessoas/Pessoas-Perfil.controller.js";

// CONTROLLERS LOJAS
import "@/controllers/lojas/Loja-Usuario.controller.js";
import "@/controllers/lojas/Loja-Gerenciar.controller.js";
import "@/controllers/lojas/Loja-Consumidor.controller.js";
import "@/controllers/lojas/Loja-Segmentos.controller.js";
import "@/controllers/lojas/Loja-Perfil.controller.js";
import "@/controllers/lojas/Loja-FormaPagamento.controller.js";

// CONTROLLERS PRODUTOS
import "@/controllers/produtos/Produtos-Gerenciar.controller.js";
import "@/controllers/produtos/Produtos-Categorias.controller.js";
import "@/controllers/produtos/orderProducts.controller.js";

// CONTROLLERS OPERAÇÕES
import "@/controllers/operacoes/Logins.controller.js";
import "@/controllers/operacoes/Equipamentos.controller.js";

// CONTROLLER VENDAS
import "@/controllers/vendas/Vendas.controller.js";
import "@/controllers/vendas/Vendas-Cupom.controller.js";

// CONTROLLER MARKETING
import "@/controllers/marketing/Marketing-Configs.controller.js";

// CONTROLLER RELATÓRIOS
import "@/controllers/relatorios/Relatorios-Sinteticos.controller.js";
import "@/controllers/relatorios/Relatorios-Analiticos.controller.js";

// CONTROLLER FINANCEIRO
import "@/controllers/financeiro/Financeiro-Regionais.controller.js";
import "@/controllers/financeiro/Financeiro-FormasPagamento.controller.js";

// CONTROLLER TERMOS
import "@/controllers/termos/Termos.controller.js";

// CONTROLLER CONFIGURAÇÂO OMNICHANNEL
import "@/controllers/configuracoes/Omnichannel.controller.js";

// CONTROLLER  MARKETPLACE
import "@/controllers/configuracoes/Marketplace.controller.js";
import "@/controllers/marketplace/Marketplace-Consumidor.controller.js";

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount("#app");
